export const SOURCES = {
  FOLIO: 'folio',
  LOCAL: 'local',
};
